<script lang="ts">
    import type {MvPdfRenderService, PdfRenderedPage} from 'src/features/media-viewer/services/mv-pdf-render.service';
    import {range} from 'shared/utils/array-utils';
    import {onDestroy} from 'svelte';
    import MvPdfPagePreviewThumbnail from './MvPdfPagePreviewThumbnail.svelte';

    export let totalPages: number;
    export let heightWidthRatio: number;
    export let pdfRenderService: MvPdfRenderService;

    let renderedPages: Record<number, PdfRenderedPage>;
    const renderedPagesSubscription = pdfRenderService.getRenderedPages$().subscribe((renderedPagesData) => renderedPages = renderedPagesData);

    onDestroy(() => {
        renderedPagesSubscription.unsubscribe();
    });
</script>

<div class="pages-overview-container">
    {#each range(1, totalPages) as i}
        <MvPdfPagePreviewThumbnail renderedPage="{renderedPages[i]}"
                                   pageNumber="{i}"
                                   {pdfRenderService}
                                   {heightWidthRatio}/>
    {/each}
</div>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .pages-overview-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: @spacing-m;
    }
</style>